import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-284b563e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "current-profile-info" }
const _hoisted_2 = { class: "profile-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Your Current Profile Name:", -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode("No profile set")
const _hoisted_5 = {
  key: 0,
  class: "clinic-section"
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" This profile contains the following chart information: ")
const _hoisted_7 = { class: "clinic-list" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" No connected clinics ")
const _hoisted_9 = { class: "explanation" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Your profile name is for you to identify which collection of charts you are viewing while on Ava Connect. Changing the profile name does not update the name in your clinic chart. ")

import { computed } from "vue";
import BaseTypography from "@/ui-library/base-typography/base-typography.vue";
import { useChartGroupsStore } from "@/features/chart-groups/store/chart-groups-store";


export default /*#__PURE__*/_defineComponent({
  __name: 'chart-group-info-display',
  setup(__props) {

const chartGroupStore = useChartGroupsStore();

const chartGroup = computed(() => chartGroupStore.getSelectedChartGroup);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(BaseTypography, {
        subtitle3: "",
        bold: ""
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      (_unref(chartGroup))
        ? (_openBlock(), _createBlock(BaseTypography, {
            key: 0,
            subtitle2: "",
            bold: "",
            class: "profile-name"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(chartGroup).name), 1)
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(BaseTypography, {
            key: 1,
            subtitle2: "",
            italic: ""
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }))
    ]),
    (_unref(chartGroup))
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(BaseTypography, {
            subtitle3: "",
            class: "clinic-label"
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(chartGroup).patientConnectClinics, (clinic) => {
              return (_openBlock(), _createElementBlock("div", {
                key: clinic.id,
                class: "clinic-entry"
              }, [
                _createVNode(BaseTypography, { class: "clinic-name" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(clinic.clinicName) + " for " + _toDisplayString(clinic.patientName), 1)
                  ]),
                  _: 2
                }, 1024),
                (clinic.clinicAddress)
                  ? (_openBlock(), _createBlock(BaseTypography, {
                      key: 0,
                      class: "clinic-address",
                      small: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(clinic.clinicAddress), 1)
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true)
              ]))
            }), 128)),
            (!_unref(chartGroup).patientConnectClinics?.length)
              ? (_openBlock(), _createBlock(BaseTypography, {
                  key: 0,
                  subtitle3: "",
                  italic: ""
                }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(BaseTypography, { body2: "" }, {
        default: _withCtx(() => [
          _hoisted_10
        ]),
        _: 1
      })
    ])
  ]))
}
}

})